import React from 'react'
import Validatorjs from 'validatorjs'
import settings from '../settings'

const { isRtl } = settings
const defaultLang = isRtl ? 'fa' : 'en'
const ValidatorContext = React.createContext()

const FormValidationLangProvider = ({ children }) => {
  Validatorjs.useLang(defaultLang)

  return (
    <ValidatorContext.Provider value={{ lang: defaultLang }}>
      {children}
    </ValidatorContext.Provider>
  )
}

const useValidatorLang = () => {
  const context = React.useContext(ValidatorContext)
  if (context === undefined) {
    throw new Error(
      `useValidatorLang must be used within a FormValidationLangProvider`
    )
  }
  return context
}

export { FormValidationLangProvider, useValidatorLang }
